import { useRef } from 'react';
import { toast } from 'react-toastify';
import { IOpoDocument, IOpoSaveResult } from '@nkr/models/opo-document';

interface IProps {
    document: IOpoDocument,
    canUpload: boolean,
    pendingFile?: File | null,
    onSelect?: (document: IOpoDocument, file: File) => void,
    onUpload?: (document: IOpoDocument, file: File) => Promise<IOpoSaveResult>,
    onDownload: (document: IOpoDocument) => void,
    onError: (message: string) => void
}

const DocumentRow = ({ document, canUpload, pendingFile, onSelect, onUpload, onDownload, onError }: IProps) => {
    const fileInput = useRef<HTMLInputElement>(null);

    const handleFileSelected = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files && e.target.files[0];

        e.target.value = '';

        if (!file) {
            return;
        }

        if (onSelect) {
            onSelect(document, file);
            return;
        }

        if (document.hasFile && !window.confirm(`This will replace the current ${document.name}. Continue?`)) {
            return;
        }

        const result = await onUpload(document, file);

        if (result.success) {
            toast.success(`${document.name} uploaded`);
        } else {
            onError(result.message);
        }
    };

    const status = pendingFile
        ? `${pendingFile.name} (uploads when you save)`
        : document.hasFile ? `Uploaded ${document.uploadedOn} by ${document.uploadedByName}` : 'No file uploaded';

    return (
        <div className='file-input-group'>
            {canUpload && (
                <input ref={fileInput} type='file' accept='application/pdf,.pdf' style={{ display: 'none' }} onChange={handleFileSelected} />
            )}
            <input
                type='text'
                className='form-control'
                readOnly
                value={status}
                title={status}
                aria-label={document.name}
                style={{ cursor: canUpload ? 'pointer' : 'default', fontStyle: pendingFile ? 'italic' : undefined }}
                onClick={() => canUpload && fileInput.current?.click()}
            />
            {canUpload && (
                <button type='button' className='btn select' onClick={() => fileInput.current?.click()}>{pendingFile ? 'Change File' : 'Select File'}</button>
            )}
            {document.hasFile && !pendingFile && (
                <button type='button' className='btn view' onClick={() => onDownload(document)}>View</button>
            )}
        </div>
    );
}

export default DocumentRow;
